import type { DesignDiscipline } from "@/data/design-disciplines";
import type { PaddingSize } from "../content-section/index.marko";
import s from "./style.module.css";
export interface Input {
    sections: DesignDiscipline[];
    paddingBlock?: (PaddingSize | null)[];
}
<let/activeId=(input.sections[0].id)>
<let/showGradient="right">

<div class=s.container>
    <content-section
        as="div"
        class=s.section
        paddingInline=false
        paddingBlock=input.paddingBlock>
        <div/sidebarRef class=s.sticky data-gradient=showGradient>
            <sidebar-links
                sections=input.sections
                activeId=activeId
                onScroll(e) {
                    if (!(e.target instanceof HTMLElement)) return;

                    const { scrollWidth, clientWidth, scrollLeft } = e.target;

                    if (scrollWidth - (clientWidth + scrollLeft) <= 25) {
                        showGradient = "left";
                    } else if (scrollLeft > 25) {
                        showGradient = "both";
                    } else {
                        showGradient = "right";
                    }
                }/>
        </div>
        <main-content
            sections=input.sections
            sidebarRef=sidebarRef
            activeId=activeId
            onIntersect(s) {
                activeId = s;
            }/>
    </content-section>
</div>
